module.exports = __webpack_public_path__ + "media/23.79fe0143.mp3";